<template>
  <div class="Container">
    <h2 class="ViewHeading">Temperature Testing</h2>
    <b-modal
      ref="RiskAssessmentPreModal"
      id="RiskAssessmentPreModal"
      title="Temperature Test Pre Questionnaire"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      size="lg"
      hide-footer
    >
      <b-card v-if="this.ScheduledRiskAssessmentItems.length == 0">
        <p>
          There are no current Scheduled Temperature Tests for this location.
        </p>
        <p>Press submit to proceed with a new Temperature Test.</p>
      </b-card>
      <b-card v-if="this.ScheduledRiskAssessmentItems.length > 0">
        <p>
          There are Temperature Tests scheduled for this location, please select
          if you are completing one of the below:
        </p>
        <br />
        <b-table
          sticky-header
          no-border-collapse
          responsive
          :items="ScheduledRiskAssessmentItems"
          :fields="ScheduledRiskAssessmentFields"
          hover
          small
        >
          <template v-slot:cell(Selected)="{ item }">
            <section v-on:click="ResetWithoutScheduled()">
              <b-form-checkbox v-model="item.Selected"></b-form-checkbox>
            </section>
          </template>
        </b-table>
      </b-card>
      <br />
      <b-row>
        <b-col cols="10">Proceed without Scheduled Appointment</b-col>
        <b-col cols="2"
          ><b-form-checkbox v-model="WithoutScheduled"></b-form-checkbox
        ></b-col>
      </b-row>

      <b-row>
        <b-col
          ><b-button v-on:click="PreAssessmentSubmit()" variant="outline-info"
            >Submit</b-button
          ></b-col
        >
        <b-col
          ><b-button v-on:click="PreAssessmentCancel()" variant="outline-info"
            >Cancel</b-button
          ></b-col
        >
      </b-row>
    </b-modal>
    <b-modal
      ref="AddActionModal"
      id="AddActionModal"
      title="New Temperature Reading"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card>
        <b-row class="text-left">
          <b-col cols="6"> Outlet ID </b-col>
          <b-col cols="6">
            <b-form-input v-model="OutletID"> </b-form-input>
          </b-col>
        </b-row>
        <b-row class="text-left">
          <b-col>
            Enter only one temperature to two decimal places
          </b-col>
        </b-row>
        <b-row class="text-left">
          <b-col cols="6"> Hot Temperature </b-col>
          <b-col cols="6">
            <b-form-input v-model="HotTempInput"> </b-form-input>
          </b-col>
        </b-row>
        <b-row class="text-left">
          <b-col cols="6"> Cold Temperature </b-col>
          <b-col cols="6">
            <b-form-input v-model="ColdTempInput"> </b-form-input>
          </b-col>
        </b-row>
        <b-row class="text-left">
          <b-col cols="6"> Mixed Temperature </b-col>
          <b-col cols="6">
            <b-form-input v-model="MixedTempInput"> </b-form-input>
          </b-col>
        </b-row>
        <b-row class="text-left">
          <b-col cols="6"> Return Temperature</b-col>
          <b-col cols="6">
            <b-form-input v-model="ReturnTempInput"> </b-form-input>
          </b-col>
        </b-row>
        <b-row
          ><b-col
            ><b-button
              size="sm"
              variant="outline-info"
              v-on:click="SubmitActionModal()"
              >Save Temperature
            </b-button></b-col
          >
          <b-col
            ><b-button
              size="sm"
              variant="outline-info"
              v-on:click="CancelActionModal()"
              >Cancel Temperature</b-button
            ></b-col
          ></b-row
        >
      </b-card>
    </b-modal>
    <b-modal
      ref="WaterTestInfoModal"
      id="WaterTestInfoModal"
      title="Water Test Information"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
    >
      <h5>Test Information</h5>
      <b-row>
        <b-col cols="6"> <b> Test ID </b> </b-col>
        <b-col cols="6"> <b> Sample ID </b> </b-col>
      </b-row>
      <b-row>
        <b-col cols="6"> {{ this.TestID }} </b-col>
        <b-col cols="6"> {{ this.SampleID }} </b-col>
      </b-row>
    </b-modal>
    <b-card>
      <b-button
        variant="info"
        v-on:click="
          ServiceRequestInfo(),
            ShowEntryModal(),
            (NewActionsList = []),
            (WithoutScheduled = false)
        "
        size="sm"
        >Register New Manual Temperature Test</b-button
      >
      <section v-if="this.ChosenAppointment != ''">
        <b-row>
          <b-col>
            {{ this.selectedlocation }}
          </b-col>
        </b-row>

        <b-row> <b-col> General Test Information</b-col> </b-row>

        <b-row>
          <b-col cols="3">Test Date</b-col>
          <b-col cols="3">
            <b-form-datepicker
              class="DatePickerInstaller"
              type="date"
              v-model="selectedDate"
              :placeholder="selectedDate"
              @focus="modal = false"
          /></b-col>
          <b-col cols="3">Test Time</b-col>
          <b-col cols="3">
            <b-form-timepicker
              id="TimeRaised"
              v-model="selectedTime"
            ></b-form-timepicker
          ></b-col>
        </b-row>
        <hr />
        <!-- <b-row v-for="(id, idx) in this.filterInfo" :key="idx"> -->

        <!-- <b-row><b-col> Test Results</b-col> </b-row> -->
        <!-- <b-row>
          <b-col cols="4"> Outlet ID </b-col>
          <b-col cols="2"> Hot Temp </b-col>
          <b-col cols="2"> Cold Temp </b-col>
          <b-col cols="2"> Mixed Temp </b-col>
          <b-col cols="2"> Return Temp </b-col>
        </b-row> -->

        <!-- <b-row v-for="(id, idx) in this.NumOfOutlets" :key="idx">
          <b-col cols="4"> Outlet ID </b-col>
          <b-col cols="2"> Hot Temp </b-col>
          <b-col cols="2"> Cold Temp </b-col>
          <b-col cols="2"> Mixed Temp </b-col>
          <b-col cols="2"> Return Temp </b-col>
        </b-row> -->

        <b-card no-body>
          <template #header>
            Test Results
          </template>
          <b-card-body>
            <b-row class="actionrow">
              <b-col class="headercol" cols="3">Outlet ID </b-col>
              <b-col class="headercol" cols="2">Hot Temp</b-col>
              <b-col class="headercol" cols="2">Cold Temp</b-col>
              <b-col class="headercol" cols="2">Mixed Temp</b-col>
              <b-col class="headercol" cols="2">Return Temp</b-col>
              <b-col cols="1" class="headercol"></b-col>
            </b-row>
            <b-row v-if="this.NewActionsList.length == 0">
              <b-col class="text-center">No Current Temperature Tests</b-col>
            </b-row>

            <b-row
              v-for="(NewAction, id) in this.NewActionsList"
              :key="id"
              class="actionrow"
            >
              <b-col class="bodycol" cols="3">{{ NewAction.OutletID }}</b-col>
              <b-col class="bodycol" cols="2">{{ NewAction.HotTemp }}</b-col>
              <b-col class="bodycol" cols="2">{{ NewAction.ColdTemp }}</b-col>
              <b-col class="bodycol" cols="2">{{ NewAction.MixedTemp }}</b-col>
              <b-col class="bodycol" cols="2">{{ NewAction.ReturnTemp }}</b-col>
              <b-col cols="1" class="bodycol"
                ><b-button
                  variant="outline-danger"
                  size="sm"
                  v-on:click="removeAction(id)"
                  ><BIconXSquare></BIconXSquare></b-button
              ></b-col>
            </b-row>
            <br />
          </b-card-body>
        </b-card>
        <b-row>
          <b-col
            ><b-button
              variant="outline-success"
              size="sm"
              v-on:click="addNewAction()"
              ><BIconPlusSquare></BIconPlusSquare> New Outlet
              Temperature</b-button
            ></b-col
          >
        </b-row>

        <b-row>
          <b-button variant="outline-info" v-on:click="BeginWaterTest()">
            Submit
          </b-button>
          <b-button variant="outline-info" v-on:click="resetFunction()">
            Cancel
          </b-button>
        </b-row>
      </section>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import {
  BIconXSquare,
  BIconPlusSquare,
} from "bootstrap-vue/dist/bootstrap-vue.esm";
export default {
  computed: {},
  components: { BIconXSquare, BIconPlusSquare },

  data() {
    return {
      NewActionsList: [],
      dataToDisplay: [],
      UserURN: localStorage.getItem("UserURN"),
      UserProfile: localStorage.getItem("ProfilePortal"),
      clCompany: localStorage.getItem("Company"),
      nickname: localStorage.getItem("Nickname"),
      ScheduledRiskAssessmentItems: [],
      selectedlocation: localStorage.getItem("location"),
      ScheduledRiskAssessmentFields: [
        { key: "Date", label: "Date" },
        { key: "NumberOfOutlets", label: "Number Of Outlets" },
        { key: "LocationNote", label: "Location Note" },
        { key: "Selected", label: "" },
      ],
      ChosenAppointment: "",
      SpeedofTest: "",
      TypeofTest: "",
      devicePosition: "",
      PositionArray: [],
      feedArray: [],
      OutletType: "",
      selectedDate: "",
      selectedTime: "",
      TypeofFlush: "",
      Description: "",
      ServiceNote: "",
      dateOptions: { day: "numeric", month: "numeric", year: "numeric" },
      OutletID: "",
      SampleID: "",
      TestID: "",
      NumOfOutlets: null,
      HotTempInput: "",
      ColdTempInput: "",
      MixedTempInput: "",
      ReturnTempInput: "",
      WithoutScheduled: "",
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl2 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders2 = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "PositionFeed" };
    axios
      .post(LookUpUrl2, this.LookUpRequest, LookUpHeaders2)
      .then((response) => {
        this.feedList = response.data.Feeds;
        this.Positions = response.data.Positions;
        for (let i = 0; i < this.feedList.length; i++) {
          var QuoteStr = this.feedList[i][0];
          this.feedArray.push({ id: QuoteStr, value: this.feedList[i][1] });
        }
        for (let i = 0; i < this.Positions.length; i++) {
          var QuoteStr2 = this.Positions[i][0];
          this.PositionArray.push({
            id: QuoteStr2,
            value: this.Positions[i][1],
          });
        }
        this.ServiceRequestInfo();
      });
  },

  methods: {
    CancelActionModal() {
      this.$refs["AddActionModal"].hide();
    },
    SubmitActionModal() {
      if (
        (this.OutletID != "") &
        (this.HotTempInput != "" ||
          this.ColdTempInput != "" ||
          this.MixedTempInput != "" ||
          this.ReturnTempInput != "")
      ) {
        this.NewAction = {
          OutletID: this.OutletID,
          HotTemp: this.HotTempInput,
          ColdTemp: this.ColdTempInput,
          MixedTemp: this.MixedTempInput,
          ReturnTemp: this.ReturnTempInput,
        };
        this.NewActionsList.push(this.NewAction);
        alert("Temperature Reading Added to List");
        this.$refs["AddActionModal"].hide();
      } else {
        alert("Please ensure the Outlet ID and one temperature is filled in");
      }
    },
    addNewAction() {
      (this.NewAction = {
        OutletID: null,
        HotTemp: null,
        ColdTemp: null,
        MixedTemp: null,
        ReturnTemp: null,
      }),
        (this.OutletID = ""),
        (this.HotTempInput = "");
      this.ColdTempInput = "";
      this.MixedTempInput = "";
      this.ReturnTempInput = "";
      this.$refs["AddActionModal"].show();
    },
    removeAction(item) {
      this.NewActionsList.splice(item, 1);
      alert("Action Removed");
    },
    getSecondPart(str) {
      return str.split("- ")[1];
    },
    ServiceRequestInfo() {
      let LookUpUrlScheduledTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/outlets";
      let LookUpHeadersScheduledTests = this.$apikeyPost;
      let LookUpRequestScheduledTests = {
        RequestType: "LoadScheduledManualTempChecks",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduledTests,
          LookUpRequestScheduledTests,
          LookUpHeadersScheduledTests
        )
        .then((response) => {
          let RiskAssessArray = [];
          this.ScheduledRiskAssessmentItems = [];
          RiskAssessArray = response.data.Values;

          for (let i = 0; i < RiskAssessArray.length; i++) {
            let NoOfOutlets = this.getSecondPart(RiskAssessArray[i][3]);

            this.ScheduledRiskAssessmentItems.push({
              ID: RiskAssessArray[i][0],
              NumberOfOutlets: NoOfOutlets,
              ServiceNote: RiskAssessArray[i][3],
              ArrangedBy: RiskAssessArray[i][8],
              Time: RiskAssessArray[i][10],
              ContactName: RiskAssessArray[i][12],
              ContactEmail: RiskAssessArray[i][13],
              ContactNote: RiskAssessArray[i][14],
              Date: RiskAssessArray[i][9],

              Room: RiskAssessArray[i][5],
              LocationNote: RiskAssessArray[i][7],
              Selected: false,
            });
          }
        });
      // this.$refs["RiskAssessmentPreModal"].show();
    },

    ShowEntryModal() {
      this.$refs["RiskAssessmentPreModal"].show();
    },

    BeginWaterTest() {
      if (
        (this.selectedDate != "") &
        (this.selectedTime != "") &
        (this.NewActionsList != [])
      ) {
        let dbformatdate = null;

        if (this.selectedDate.includes("/")) {
          let dt1 = parseInt(this.selectedDate.substring(0, 2));
          let mon1 = parseInt(this.selectedDate.substring(3, 5));
          let yr1 = parseInt(this.selectedDate.substring(6, 10));
          dbformatdate = yr1 + "-" + mon1 + "-" + dt1;
        } else {
          dbformatdate = this.selectedDate;
        }

        let name = localStorage.getItem("fullname");
        let LookUpUrlScheduledTests =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/outlets";
        let LookUpHeadersScheduledTests = this.$apikeyPost;
        let LookUpRequestScheduledTests = {
          RequestType: "SubmitManualTempCheck",
          DataDict: [
            {
              ReadingDate: dbformatdate,
              ReadingTime: this.selectedTime,
              ReadingTakenBy: name,
              Location: this.selectedlocation,
              ServiceID: this.ChosenAppointment,
              CheckList: this.NewActionsList,
            },
          ],
        };
        axios
          .post(
            LookUpUrlScheduledTests,
            LookUpRequestScheduledTests,
            LookUpHeadersScheduledTests
          )
          .then((response) => {
            this.SampleID = response.data.SampleID;
            this.TestID = response.data.TestID;

            // WaterTestInfoModal
            this.$refs["WaterTestInfoModal"].show();

            this.resetFunction();
          });
      } else {
        alert(
          "Please ensure that the date, time and at least one reading is input"
        );
      }
    },

    resetFunction() {
      this.NewActionsList = [];
      this.OutletID = "";
      this.SpeedofTest = "";
      this.TypeofTest = "";
      this.TypeofFlush = "";
      this.Description = "";
      this.OutletType = "";
      this.selectedDate = "";
      this.selectedTime = "";
      this.showQuestions = "false";
      this.devicePosition = [];
      this.ChosenAppointment = "";
      this.RiskAssessArray = [];
      this.ChosenAppointment = [];
      // this.PreAssessmentSubmit();
    },

    PreAssessmentSubmit() {
      this.ChosenAppointment = "";

      if (this.ScheduledRiskAssessmentItems.length == 0) {
        this.ChosenAppointment = "None";
      } else if (this.ScheduledRiskAssessmentItems.length > 0) {
        for (let u = 0; u < this.ScheduledRiskAssessmentItems.length; u++) {
          if (this.ScheduledRiskAssessmentItems[u].Selected == true) {
            this.ChosenAppointment = this.ScheduledRiskAssessmentItems[u].ID;
            this.selectedDate = this.ScheduledRiskAssessmentItems[u].Date;
            this.selectedTime = this.ScheduledRiskAssessmentItems[u].Time;
            this.Description = this.ScheduledRiskAssessmentItems[
              u
            ].LocationNote;
            this.ServiceNote = this.ScheduledRiskAssessmentItems[u].ServiceNote;

            this.NumOfOutlets = Number(
              this.ScheduledRiskAssessmentItems[u].NumberOfOutlets
            );

            // this.AssessmentObject.Details.Date = this.ScheduledRiskAssessmentItems[
            //   u
            // ].Date;
            // this.AssessmentObject.Details.Room = this.ScheduledRiskAssessmentItems[
            //   u
            // ].Room;
            // this.AssessmentObject.Details.Assessor = this.name;
            // this.AssessmentObject.Details.LocationNote = this.ScheduledRiskAssessmentItems[
            //   u
            // ].LocationNote;
            // this.AssessmentObject.Details.Time = this.ScheduledRiskAssessmentItems[
            //   u
            // ].Time;
            // this.AssessmentObject.Details.ServiceNote = this.ScheduledRiskAssessmentItems[
            //   u
            // ].ServiceNote;
            // this.AssessmentObject.Details.ArrangedBy = this.ScheduledRiskAssessmentItems[
            //   u
            // ].ArrangedBy;
            // this.AssessmentObject.Details.ContactName = this.ScheduledRiskAssessmentItems[
            //   u
            // ].ContactName;
            // this.AssessmentObject.Details.ContactEmail = this.ScheduledRiskAssessmentItems[
            //   u
            // ].ContactEmail;
            // this.AssessmentObject.Details.ContactNote = this.ScheduledRiskAssessmentItems[
            //   u
            // ].ContactNote;
            break;
          } else {
            this.ChosenAppointment = "None";
          }
        }
      }

      this.$refs["RiskAssessmentPreModal"].hide();
      this.showQuestions = "true";
    },
    PreAssessmentCancel() {
      this.$refs["RiskAssessmentPreModal"].hide();
    },

    resetSelectedPreExist() {
      for (let u = 0; u < this.ScheduledRiskAssessmentItems.length; u++) {
        if (this.ScheduledRiskAssessmentItems[u].Selected == true) {
          this.ScheduledRiskAssessmentItems[u].Selected = false;
        }
      }
    },

    ResetWithoutScheduled() {
      this.WithoutScheduled = false;
    },

    //  OLD
    getDataToAction() {},
    DeviceAction() {},
  },
  watch: {
    WithoutScheduled() {
      this.resetSelectedPreExist();
    },
  },
};
</script>

<style scoped>
div {
  float: left;
  width: 100%;
  padding: 10px;
}
</style>
